<template>
  <Box :class="classes" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)">
    {{ text }} 
  </Box>
</template>

<script>

export default {
  props: {
    verticalAlignment: {
      type: String
    },
    textAlignment: {
      type: String
    },
    fontSize: {
      type: Number
    },
    color: {
      type: String
    },
    text: {
      type: [String, Number]
    },
    textWrap: {}
  },
  computed: {
    classes () {
      let classes = [
        'web-label'
      ]

      if (this.wrap) {
        classes.push('wrap')
      }

      return classes.join(' ')
    },
    wrap () {
      return this.textWrap === 'true' || this.textWrap === '' || this.textWrap === true
    }
  },
  watch: {
    color: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.color = to
        })
      }
    },
    textAlignment: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.textAlign = to
        })
      }
    },
    verticalAlignment: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.alignSelf = to
        })
      }
    },
    fontSize: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.fontSize = to + 'px'
        })
      }
    }
  }
}

</script>

<style scoped lang="scss">

.web-label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.web-label.wrap {
  white-space: normal;
  text-overflow: unset;
  overflow: visible;
}

</style>